module.exports = __webpack_public_path__ + "img/color2_on.2374ff36.png";